
import * as constants from "./loginConstants"

export const setLoginPageUrl = (loginPageUrl: string): constants.SetLoginPageUrl => {
  return {
    type: constants.SET_LOGIN_PAGE_URL_VALUE,
    loginPageUrl: loginPageUrl,
  }
}
